/* eslint-disable camelcase */

export default {
	sharedNotePlaceholder: "Add topics, take some notes, or choose a template to get started",
	privateNotePlaceholder: "Add some private notes...",
};
